<template>
  <div class="panel-container">
    <DocumentPanelDialog v-if="isDocumentModalOpened" />
    <CollectionsPanelDialog v-if="isCollectionsModalOpened" />
    <FavoritesPanelDialog v-if="isFavoritesModalOpened" />
    <NotificationsPanelDialog v-if="isNotificationsModalOpened" />
    <CreateCollectionPopup />
    <AddToCollectionPopup v-if="addToCollectionPopupState.open" />
    <ShareCollectionPopup v-if="sharedLinkCollectionState.open" />
  </div>
</template>

<script>
import { computed } from 'vue';
import { CURRENT_DIALOG } from '~/constants/conversationModels';
import useModals from '~/composables/useModals';
import NotificationsPanelDialog from '~/components/conversation/notificationsPanel/NotificationsPanelDialog.vue';
import CollectionsPanelDialog from '~/components/conversation/collections/CollectionsPanelDialog.vue';
import DocumentPanelDialog from '~/components/conversation/documentPanel/DocumentPanelDialog.vue';
import CreateCollectionPopup from '~/components/conversation/collections/CreateCollectionPopup.vue';
import FavoritesPanelDialog from '~/components/conversation/favoritesPanel/FavoritesPanelDialog.vue';
import AddToCollectionPopup from '~/components/conversation/collections/AddToCollectionPopup.vue';
import ShareCollectionPopup from '~/components/conversation/collections/ShareCollectionPopup';

export default {
  name: 'AccountControlPanels',
  components: {
    AddToCollectionPopup,
    FavoritesPanelDialog,
    CreateCollectionPopup,
    DocumentPanelDialog,
    CollectionsPanelDialog,
    NotificationsPanelDialog,
    ShareCollectionPopup,
  },

  setup() {
    const { currentDocumentsDialog, addToCollectionPopupState, sharedLinkCollectionState } = useModals();

    const isDocumentModalOpened = computed(() => currentDocumentsDialog.value === CURRENT_DIALOG.document_panel);
    const isFavoritesModalOpened = computed(() => currentDocumentsDialog.value === CURRENT_DIALOG.favorites_panel);
    const isCollectionsModalOpened = computed(() => currentDocumentsDialog.value === CURRENT_DIALOG.collections_panel);
    const isNotificationsModalOpened = computed(
      () => currentDocumentsDialog.value === CURRENT_DIALOG.notifications_panel,
    );

    return {
      isCollectionsModalOpened,
      isDocumentModalOpened,
      isFavoritesModalOpened,
      isNotificationsModalOpened,
      addToCollectionPopupState,
      sharedLinkCollectionState,
    };
  },
};
</script>

<style scoped lang="scss">
.panel-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 16px 16px 16px 0;
}
</style>
